
export default class FormValidator {

    constructor(table, document) {
        this.table = table
        this.document = document
    }

    isValid() {
        let fields = this.table.fields

        // NOTE: the field "index" is actually its ID
        for (let i = 0; i < fields.length; i++) {
            let field = fields[i]

            if(!this.isFieldValid(field)) {
                return false
            }
        }

        return true
    }

    isFieldValid(field) {
        if(field.required) {
            let fieldValue = this.document[field.index]

            if(fieldValue === undefined || fieldValue === null || fieldValue === '' ) {
                return false
            }

            if(field.field_type === 'Number' && !this.isValidNumber(fieldValue)) {
                return false
            }

            if(field.name.toLowerCase().indexOf('email') > -1) {
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValue)
            }
        }

        return true
    }

    isValidNumber(fieldValue) {
        return !isNaN(fieldValue)
    }
}